import axios from "axios";
import { serverHost } from "../../../../http_common.js";

const host = serverHost;

const endpoint = (path) => `${host}${path}`;

export const getFDCProfile = async (staffId) => {
  const response = await axios.get(endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/profile`));
  return response.data;
};

export const updateFDCProfile = async (staffId, payload) => {
  const response = await axios.patch(
    endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/profile`),
    payload
  );
  return response.data;
};

export const getFDCDashboard = async (staffId) => {
  const response = await axios.get(endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/dashboard`));
  return response.data;
};

export const getFDCSettings = async (staffId) => {
  const response = await axios.get(endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/settings`));
  return response.data;
};

export const updateFDCSettings = async (staffId, payload) => {
  const response = await axios.patch(
    endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/settings`),
    payload
  );
  return response.data;
};

export const fdcRequest = async (staffId, path, method = "get", data, options = {}) => {
  const response = await axios({ url: endpoint(`/fdc/staff/${encodeURIComponent(staffId)}/${path}`), method, ...(data !== undefined && { data }), timeout: 30000, ...options });
  if (response.data?.status >= 400) throw new Error(response.data.message || "The operation could not be completed.");
  return response.data;
};

export const fdcAdminRequest = async (path, method = "get", data) => {
  const response = await axios({ url: endpoint(`/fdc/administration/${path}`), method, ...(data !== undefined && { data }), timeout: 30000 });
  return response.data;
};

export const newFDCReference = () => {
  if(window.crypto?.randomUUID)return window.crypto.randomUUID();
  const bytes=window.crypto.getRandomValues(new Uint8Array(16));bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128;
  const hex=Array.from(bytes,b=>b.toString(16).padStart(2,"0")).join("");return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
};
